<template>
  <div class="type">
    <div class="type-top">
      <div class="type-top-left"></div>
      {{typeTitle}}
    </div>
    <div class="MessageBox" v-if="InfoturesTypeData">
      <div v-for="(item , index) of InfoturesTypeData.lstAttachment" :key="index" class="FormBox">
        <div class="FileLinkMan BoxStyle">
          <div class="title">公司负责人：</div>
          <div class="titleVal">{{ item.CompanyChargeName }}</div>
        </div>
        <div class="FileLinkTel BoxStyle">
          <div class="title">公司负责人电话：</div>
          <div class="titleVal">{{ item.CompanyChargePhone }}</div>
        </div>
        <div class="FileEMail BoxStyle">
          <div class="title">公司负责人邮箱：</div>
          <div class="titleVal">{{ item.CompanyChargeEmail }}</div>
        </div>
        <div class="FileReceiveAddress BoxStyle">
          <div class="title">数据上报联系人：</div>
          <div class="titleVal">{{ item.DataUploadName }}</div>
        </div>
        <div class="FileReceiveAddress BoxStyle">
          <div class="title">数据上报联系人电话：</div>
          <div class="titleVal">{{ item.DataUploadPhone }}</div>
        </div>
        <div class="FileReceiveAddress BoxStyle">
          <div class="title">数据上报联系人邮箱：</div>
          <div class="titleVal">{{ item.DataUploadEmail }}</div>
        </div>
        <div class="FileReceiveAddress BoxStyle">
          <div class="title">收货联系人：</div>
          <div class="titleVal">{{ item.DeliveryName }}</div>
        </div>
        <div class="FileReceiveAddress BoxStyle">
          <div class="title">收货联系电话：</div>
          <div class="titleVal">{{ item.DeliverPhone }}</div>
        </div>
        <div class="FileReceiveAddress BoxStyle">
          <div class="title">收货地址：</div>
          <div class="titleVal">{{ item.DeliveryAddress }}</div>
        </div>
        <div class="FileReceiveAddress BoxStyle">
          <div class="title">发票联系人：</div>
          <div class="titleVal">{{ item.InvoiceName }}</div>
        </div>
        <div class="FileReceiveAddress BoxStyle">
          <div class="title">发票联系电话：</div>
          <div class="titleVal">{{ item.InvoicePhone }}</div>
        </div>
        <div class="FileReceiveAddress BoxStyle">
          <div class="title">发票收件地址：</div>
          <div class="titleVal">{{ item.InvoiceAddress }}</div>
        </div>
        <div class="FileReceiveAddress BoxStyle">
          <div class="title">文件联系人：</div>
          <div class="titleVal">{{ item.FileLinkMan }}</div>
        </div>
        <div class="FileReceiveAddress BoxStyle">
          <div class="title">文件联系人电话：</div>
          <div class="titleVal">{{ item.FileLinkTel }}</div>
        </div>
        <div class="FileReceiveAddress BoxStyle">
          <div class="title">文件联系人邮箱：</div>
          <div class="titleVal">{{ item.FileEMail  }}</div>
        </div>
         <div class="FileReceiveAddress BoxStyle">
          <div class="title">文件收件地址：</div>
          <div class="titleVal">{{ item.FileReceiveAddress   }}</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import FilesAndPictures from '@/components/FilesAndPictures.vue'
export default {
  components: {
    FilesAndPictures
  },
  props: {
    InfoturesTypeData: {
      type: Object
    },
    typeTitle: {
      type: String
    }
  },
  data() {
    return {
    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {
    imgShowClick(par) {
      this.$emit('imgShowClick', par)
    },
    See(par) {
      this.$emit('See', par)
    }
  },
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
@import url("../index.less");
.MessageBox {
  width: 101%;
  // height: 500px;

  .BoxStyle {
    line-height: 32px;
    border-radius: 2px;
    border: 1px solid rgb(230 230 230);
    cursor: pointer;
    display: inline-block;
    position: relative;
    min-width: 250px;
    height: 32px;
    color: rgb(0 0 0);
    font-size: 12px;
    background-color: rgb(250 251 252);
    margin-top: 10px;
    margin-left: 20px;
    padding-left: 20px;
    padding-right: 20px;

    .title {
      display: inline-block;
    }

    .titleVal {
      display: inline-block;
    }
  }
  .FormBox {
    border-bottom: 1px solid rgb(230 230 230);
    padding-bottom: 10px;
  }
}
</style>